"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFingerprintId = void 0;
/**
 * Wrapper for fetching a Fingerprint device ID from Fingerprint's API.
 * Handles caching and error handling in a common and consistent way.
 *
 * Failures or skipping fetching will result in an `undefined` return value; these
 * should be handled by the consumer (most likely by just falling back to a standard
 * Segment anonymous ID).
 *
 * @param _apiKey {optional}: The API key from the Fingerprint dashboard. If not provided,
 *  a call will not be attempted.
 */
const getFingerprintId = async (_apiKey) => {
    return undefined;
};
exports.getFingerprintId = getFingerprintId;
